import { Box, Loader } from '@bcp-nextgen-dx-component-factory/design-system';
import { useIsVisibleLoader } from '@hooks';

export const GlobalLoader = () => {
	const isVisible = useIsVisibleLoader('global');

	return (
		<>
			{isVisible && (
				<Box
					styles={{
						display: 'block',
						position: 'fixed',
						top: 0,
						left: 0,
						zIndex: 1000,
						// backgroundColor: 'transparent',
						backgroundColor: '#3f3f3f71',
						backdropFilter: 'blur(10px)',
						width: '100vw',
						height: '100vh',
					}}
				>
					<Box
						styles={{
							height: '100%',
							justifyContent: 'center',
						}}
					>
						<Loader />
					</Box>
				</Box>
			)}
		</>
	);
};
